import React, { useEffect, useState } from "react";
import { Modal,Form, Input, Button, message, DatePicker, InputNumber } from "antd";
import { MakeApiCall } from "../../../../apis";
import { Wrapper } from "../style";
import dayjs from "dayjs";

const AddCogs = ({ visible, onClose, onSave,getList, product, userData }) => {

    console.log(userData)
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && product) {
            form.setFieldsValue({
                item_cogs: product?.item_cogs || "", // Set existing cost per unit
                item_cogs_batch_start_date: product?.item_cogs_batch_start_date ? dayjs(product.item_cogs_batch_start_date) : null, // Convert timestamp to DatePicker value
            });
        } else {
            form.resetFields(); // Reset form on close
        }
    }, [visible, product]);


   const handleFormSubmit = () => {
        form
          .validateFields()
          .then(async (values) => {
            console.log(values, 'values');
      
            // Process form values
            const formattedData = {
                item_cogs: values.item_cogs,
                item_cogs_batch_start_date: values.item_cogs_batch_start_date 
                ? dayjs(values.item_cogs_batch_start_date, "DD-MM-YYYY").format("YYYY-MM-DD") 
                : null, 
            };
            console.log(formattedData, 'formattedData');
      
            try {
              const response = await MakeApiCall(`update-product/${product?.id}`, `post`, formattedData, true, null, userData?.token );
              if (response?.status) {
                message.success(response?.message);

                onClose(false);
                form.resetFields();
      
                getList();
              } else {
                message.error(
                  response?.message);
                console.error("API Error:", response);
              }
            } catch (error) {
              message.error("Something went wrong. Please try again.");
              console.error("Request Failed:", error);
            }
          })
          .catch((errorInfo) => {
            message.error("Validation Failed");
            console.log("Validation failed:", errorInfo);
          });
      };


  return (
    <Modal
      title="Update COGS"
      open={visible}
      width={400}
      onCancel={onClose}
      footer={[
       
        <button type="button" class="btn btn-light " onClick={onClose}>Close</button>,
					<button type="button" class="btn btn-danger " onClick={() => form.submit()}> Save</button>
      ]}
    >
      <p><b>Product:</b> {product?.item_name}</p>
      <Form  className="mt-5" form={form} onFinish={handleFormSubmit} layout="vertical">
<Wrapper>
  {/*end::Input group*/}
  <div className="row g-3 mb-5 align-items-center">
    <div className="col-md-4 fv-row">
      <label className=" fs-6 fw-bold mb-2">Start date</label>
    </div>
    <div className="col-md-8 fv-row">
    <Form.Item
            name="item_cogs_batch_start_date"
            className='mb-0'
            rules={[{ required: true, message: 'Please enter Date' }]}
          >
            <DatePicker format="DD-MM-YYYY"  disabledDate={(current) => current && current < new Date().setHours(0, 0, 0, 0)}  className="form-control form-control-solid w-100 fs-7" size='large'/>
          </Form.Item>
    </div>
  </div>
  {/*end::Input group*/}
  {/*end::Input group*/}
  <div className="row g-3 mb-5 align-items-center">
    <div className="col-md-4 fv-row">
      <label className=" fs-6 fw-bold mb-2">Cost per unit</label>
    </div>
    <div className="col-md-8 fv-row">
    <Form.Item
            name="item_cogs"
            className='mb-0'
            rules={[{ required: true, message: 'Please enter Cost' }]}
          >
            <InputNumber className="w-100" variant="filled" size='large'/>
          </Form.Item>
    </div>
  </div>
  {/*end::Input group*/}
</Wrapper>
       
        </Form>
    </Modal>
  );
};

export default AddCogs;
